export function createAfterCursor(currentPage, pageSize) {
    if (currentPage === 1) {
        return null;
    }

    // The cursor is just an base64 encoded string containing the
    // offset counted from zero.
    return btoa(`arrayconnection:${pageSize * (currentPage - 1) - 1}`);
}
